import type { RouterOutputs } from "../../../../api/types";

export type ParkerVehicle = RouterOutputs["parkers"]["getParkerVehicles"]["items"][number];

export const vehicleKey = (vehicle: { plate: string; state: string }) => `${vehicle.plate}__${vehicle.state}`;
